(function (ng) {
    

    angular.module('transformer', []);
})(window.angular);
